import React from 'react'
export function InputForm(props){
    return (
        <div className={(props.className?props.className:"")+" width-100"}>
            <input type={props.type} id={props.id} name={props.name} onChange={props.onChange} placeholder={props.placeholder} className="brd-glb paddAll-10 bdg-inp rad-5 sizeF-1em width-100 box-border" value={props.value}/>
        </div>
    )
}